export default "__VITE_ASSET__da7956ad__"